module.exports = __webpack_public_path__ + "assets/img/schoolbus-m.05b27fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/schoolbus-m.jpg
// module id = yyfU
// module chunks = 0